import { UseQueryResult, useQuery, useMutation } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getAssetsListService } from 'domains/assets/services/assets.service';
import { TAssetsListResData, TAssetsListReqParams } from 'domains/assets/types/assets.types';

export const useGetAssetsListQuery = (
  counterpartyGUID: string,
  params?: TAssetsListReqParams,
  options?: any,
): UseQueryResult<TAssetsListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.AssetQueryKeys].getAssetsList_MultiRole(counterpartyGUID, params),
    ...options,
  });

export const useGetAssetsListAdminQuery = (
  params?: TAssetsListReqParams,
  options?: any,
): UseQueryResult<TAssetsListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.AssetQueryKeys].getAssetsListAdmin(params),
    ...options,
  });

export const useGetAssetsListMutation = (): any =>
  useMutation({
    mutationFn: (data: {
      counterpartyGUID: string;
      params?: TAssetsListReqParams }) =>
      getAssetsListService(data.counterpartyGUID, data.params),
  });
